// src/api/register/useRegisterPassword.ts

import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { RegisterPasswordRequest } from "../../../interface/IRegister";
import {
  GeneralResponse,
  IuserDetails,
} from "../../../interface/GeneralResponse";
import Api from "../../generalApi/Api";
import { Methods } from "../../../Constants/ApiConstants";
import { EndPoints } from "../../../Constants/endpoints";
import { setUserDetails } from "../../../redux/reducers/registrationSlice";
import { setUserAuthenticated } from "../../../redux/reducers/userSlice";

const useRegisterPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (
      data: RegisterPasswordRequest,
    ): Promise<GeneralResponse<IuserDetails>> => {
      if (!data || Object.keys(data).length === 0) {
        return Promise.reject(new Error("Invalid data"));
      }

      const values = new FormData();

      // Convert number to string before appending
      values.append("Id", data.Id.toString());
      values.append("FullName", data.FullName);
      values.append("Password", data.Password);

      return Api<FormData, GeneralResponse<IuserDetails>>({
        method: Methods.POST,
        endpoint: EndPoints.Register,
        body: values,
      });
    },
    onSuccess: (response) => {
      if (response && response.Data) {
        localStorage.setItem("token", response.Data.Token);
        dispatch(
          setUserDetails({
            ...response.Data
          } as any)
        );
        dispatch(setUserAuthenticated(true));
        navigate("/select-account-type");
      }
    }
  });
};

export default useRegisterPassword;
